import { render } from "./RejectedDayIn.vue?vue&type=template&id=22ec443f&scoped=true"
import script from "./RejectedDayIn.vue?vue&type=script&lang=js"
export * from "./RejectedDayIn.vue?vue&type=script&lang=js"

import "./RejectedDayIn.vue?vue&type=style&index=0&id=22ec443f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ec443f"]])

export default __exports__